import { defineComponent as _defineComponent } from 'vue'
import NotificationsModal from 'ah-notifications/src/components/notifications/NotificationsModal.vue';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { VButton } from 'ah-common-lib/src/common/components';
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';
import { FeatureFlag, Notification, NotificationType, profileLinkNotificationTypes } from 'ah-api-gateways';
import { useFeatureFlag } from 'ah-common-stores/src/stores/featureFlagStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'XHedgeNotificationsModal',
  setup(__props) {

const notificationsStore = useNotificationsStore();

const router = useRouter();

const hasUnreadNotifications = computed(() => notificationsStore.unreadCount > 0);

const { isActive: isVariationMarginFeatureActive } = useFeatureFlag({
  featureFlag: FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE,
});
function navigateToLimitsProfile(item: Notification) {
  if (isVariationMarginFeatureActive.value && profileLinkNotificationTypes.includes(item.type)) {
    router.push('/dashboard/trades/limits-collateral');
  } else {
    switch (item.type) {
      case NotificationType.CREDIT_PROFILE_CHANGED:
        router.push('/dashboard/trades/collateral-management');
        break;
      case NotificationType.LIMITS_PROFILE_CHANGED:
        router.push('/dashboard/trades/position-limits');
        break;
    }
  }
}

return { __sfc: true,notificationsStore, router, hasUnreadNotifications, isVariationMarginFeatureActive, navigateToLimitsProfile, NotificationsModal, VButton, profileLinkNotificationTypes }
}

})